import diceSupport from '../assets/dice/apoio-dado.png';
import dice1 from '../assets/dice/dice1.png';
import dice2 from '../assets/dice/dice2.png';
import dice3 from '../assets/dice/dice3.png';
import dice4 from '../assets/dice/dice4.png';
import dice5 from '../assets/dice/dice5.png';
import dice6 from '../assets/dice/dice6.png';
import rollingDice01 from '../assets/dice/rolling-dice-01.png';
import rollingDice02 from '../assets/dice/rolling-dice-02.png';
import rollingDice03 from '../assets/dice/rolling-dice-03.png';
import rollingDice04 from '../assets/dice/rolling-dice-04.png';
import rollingDice05 from '../assets/dice/rolling-dice-05.png';
import rollingDice06 from '../assets/dice/rolling-dice-06.png';
import rollingDice07 from '../assets/dice/rolling-dice-07.png';
import rollingDice08 from '../assets/dice/rolling-dice-08.png';
import rollingDice09 from '../assets/dice/rolling-dice-09.png';
import rollingDice10 from '../assets/dice/rolling-dice-10.png';
import rollingDice11 from '../assets/dice/rolling-dice-11.png';
import rollingDice12 from '../assets/dice/rolling-dice-12.png';
import rollingDice13 from '../assets/dice/rolling-dice-13.png';
import rollingDice14 from '../assets/dice/rolling-dice-14.png';
import rollingDice15 from '../assets/dice/rolling-dice-15.png';
import rollingDice16 from '../assets/dice/rolling-dice-16.png';
import rollingDice17 from '../assets/dice/rolling-dice-17.png';
import rollingDice18 from '../assets/dice/rolling-dice-18.png';
import rollingDice19 from '../assets/dice/rolling-dice-19.png';
import rollingDice20 from '../assets/dice/rolling-dice-20.png';
import rollingDice21 from '../assets/dice/rolling-dice-21.png';
import rollingDice22 from '../assets/dice/rolling-dice-22.png';
import rollingDice23 from '../assets/dice/rolling-dice-23.png';
import rollingDice24 from '../assets/dice/rolling-dice-24.png';
import rollingDice25 from '../assets/dice/rolling-dice-25.png';
import rollingDice26 from '../assets/dice/rolling-dice-26.png';
import rollingDice27 from '../assets/dice/rolling-dice-27.png';
import rollingDice28 from '../assets/dice/rolling-dice-28.png';
import rollingDice29 from '../assets/dice/rolling-dice-29.png';
import rollingDice30 from '../assets/dice/rolling-dice-30.png';
import rollingDice31 from '../assets/dice/rolling-dice-31.png';
import rollingDice32 from '../assets/dice/rolling-dice-32.png';
import fakeButton from '../assets/ui/botao-fake.png';
import notFakeButton from '../assets/ui/botao-nao-fake.png';

export const diceAssetUrls = [
  diceSupport,
  dice1,
  dice2,
  dice3,
  dice4,
  dice5,
  dice6,
  rollingDice01,
  rollingDice02,
  rollingDice03,
  rollingDice04,
  rollingDice05,
  rollingDice06,
  rollingDice07,
  rollingDice08,
  rollingDice09,
  rollingDice10,
  rollingDice11,
  rollingDice12,
  rollingDice13,
  rollingDice14,
  rollingDice15,
  rollingDice16,
  rollingDice17,
  rollingDice18,
  rollingDice19,
  rollingDice20,
  rollingDice21,
  rollingDice22,
  rollingDice23,
  rollingDice24,
  rollingDice25,
  rollingDice26,
  rollingDice27,
  rollingDice28,
  rollingDice29,
  rollingDice30,
  rollingDice31,
  rollingDice32
];

export const evaluationButtonAssetUrls = [
  fakeButton,
  notFakeButton
];
